<template>
  <div>
    <div class="card-header border-0 bg-transparent">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-2">{{curOrg.type === 'employer' ? 'Talent' : 'People'}}</h3>
        </div>
        <div class="col text-right">
          <button
            class="btn btn-success text-white btn-icon-only rounded-circle mt-1 mt-1 mr-3"
            @click="toggleFilters"
          >
            <i class="fa fa-filter"></i>
          </button>
          <button
            class="btn btn-primary text-white btn-icon-only rounded-circle mt-1"
            data-toggle="modal"
            data-target="#enrollPotentialee"
            v-if="curOrg.type !== 'employer' && hasRoles(['enrollPotentialee'])"
          >
            <i class="fa fa-user-plus"></i>
          </button>
        </div>
      </div>
      <potentialee-filters v-if="showFilters" />
      <div v-else>
        <h6
          class="mb-0"
        >Ordering {{$parent.orderByOptions[$parent.orderBy].name}} in a {{$parent.orderByDirOptions[$parent.orderByDir].name}} direction</h6>
      </div>
    </div>
    <modal id="enrollPotentialee" title="Enroll Potentialee">
      <enroll-potentialee-form/>
    </modal>
  </div>
</template>

<script>
import firebase from "@/config/firebase.js";
window.$ = window.jQuery = require("jquery");
require("bootstrap/dist/js/bootstrap.js");
var formBuilder;
import EnrollPotentialeeForm from "@/views/potentialees/components/EnrollPotentialeeForm.vue";
import PotentialeesFilters from "@/views/potentialees/components/PotentialeesFilters.vue";
import Modal from "@/components/Modal.vue";

export default {
  name: "potentialees-header",
  components: {
    "enroll-potentialee-form": EnrollPotentialeeForm,
    "potentialee-filters": PotentialeesFilters,
    modal: Modal
  },
  props: {
    filters: Array
  },
  data() {
    return {
      showFilters: false
    };
  },
  methods: {
    toggleFilters() {
      this.showFilters = !this.showFilters;
    }
  },
  computed: {
    hasRoles() {
      return roles => roles.every(this.hasRole);
    },
    hasRole() {
      return role => this.rolesData[role] != null || this.isOwner;
    },
    curOrg() {
      return this.$store.state.usermain.curOrg;
    },
    currentUser() {
      return this.$store.state.usermain.currentUser;
    },
    isOwner() {
      return this.$store.state.usermain.isOwner;
    },
    rolesData() {
      return this.$store.state.usermain.rolesData;
    }
  }
};
</script>
